import { h } from 'vue'
import { RouterView } from 'vue-router'
export default [
  {
    path: '/:lang/news',
    name: 'knowledge',
    component: { render: () => h(RouterView) },
    meta: {
      name: 'home.header.KnowledgeCenter.name',
      weight: 99999,
      isHide: true,
      pageCode: 'ERA.UC.KNOWLEDGE',
    },
    redirect: {
      name: 'logisticsNews',
    },
    children: [
      {
        path: '/:lang/news',
        name: 'logisticsNews',
        meta: {
          // name: 'News',
          name: 'home.header.KnowledgeCenter.News',
          icon: 'NavKnowledgeNews',
          pageCode: 'ERA.UC.NEWS.LOGISTIVS',
          type: 'logisticsNews',
          show: true,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
        children: [],
      },

      {
        path: '/:lang/news/detail/:id',
        name: 'logisticsNewsDetail',
        meta: {
          name: 'home.header.KnowledgeCenter.News.Tag.list',
          pageCode: 'ERA.UC.NEWS.LOGISTIVS.DETAIL',
        },
        component: () => import('@/pages/knowledge/News/detail.vue'),
      },

      {
        path: '/:lang/news/:tag',
        name: 'tagLogisticsNews',
        meta: {
          name: 'home.header.KnowledgeCenter.News.Tag.Page',
          pageCode: 'ERA.UC.NEWS.LOGISTIVS.TAG',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },
      {
        path: '/:lang/news/:tag/:page',
        name: 'tagPageLogisticsNews',
        meta: {
          name: 'home.header.KnowledgeCenter.News.Tag.Page',
          pageCode: 'ERA.UC.NEWS.LOGISTIVS.TAG',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },

      // 会员新闻 列表页
      {
        path: '/:lang/jctransnews',
        name: 'jctransNews',
        meta: {
          name: 'home.header.KnowledgeCenter.News',
          pageCode: 'ERA.UC.NEWS.JCTRANS',
          type: 'jctransNews',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },
      // 会员新闻 详情页
      {
        path: '/:lang/jctransnews/detail/:id',
        name: 'JctransNewsDetail',
        meta: {
          name: 'home.header.KnowledgeCenter.News.detail',
          pageCode: 'ERA.UC.NEWS.JCTRANS.DETAIL',
        },
        component: () => import('@/pages/knowledge/News/detail.vue'),
      },

      // 会员新闻 标签列表页
      {
        path: '/:lang/jctransnews/:tag',
        name: 'tagJctransNews',
        meta: {
          name: 'home.header.KnowledgeCenter.News.Tag.Page',
          pageCode: 'ERA.UC.NEWS.JCTRANS.TAG',
          type: 'jctransNews',
          show: false,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },
      // 会员新闻 标签详情页
      {
        path: '/:lang/jctransnews/:tag/:page',
        name: 'tagPageJctransNews',
        meta: {
          name: 'home.header.KnowledgeCenter.News.Tag.PAGE',
          pageCode: 'ERA.UC.NEWS.JCTRANS.TAG.DETAIL',
          type: 'jctransNews',
          show: false,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },
    ],
  },
  {
    path: '/:lang/resources',
    name: 'Resources',
    component: () => import('~/pages/resources/index.vue'),
    meta: {
      name: 'Resources',
      pageCode: 'ERA.UC.Resources',
    },
  },
  {
    path: '/:lang/blog',
    name: 'Blog',
    component: () => import('~/pages/resources/blogTag.vue'),
    meta: {
      name: 'Blog',
      pageCode: 'ERA.UC.BLOG',
    },
  },
  {
    path: '/:lang/blog/:tag/:searchValue?',
    name: 'BlogList',
    component: () => import('~/pages/resources/blogList.vue'),
    meta: {
      name: 'BlogList',
      pageCode: 'ERA.UC.BLOG.LIST',
    },
  },
  {
    path: '/:lang/blog/detail/:id',
    name: 'BlogDetail',
    component: () => import('~/pages/resources/blogDetail.vue'),
    meta: {
      name: 'BlogDetail',
      pageCode: 'ERA.UC.BLOG.DETAIL',
    },
  },
]
